import { ReactComponent as SvgCheckAlt } from "assets/svg/check-alt.svg";
import styled from "styled-components";

export const StyledCheck = styled(SvgCheckAlt)`
  position: absolute;
  top: -8px;
  right: -5px;
  z-index: 1;
`;
